/* eslint-disable react/jsx-pascal-case */
import { Button, Header, Modal, Segment } from "semantic-ui-react";


export const CasesModal = ({ open, closeBtn_Click, cases }) => {
    return (
        <Modal open={open} size='large'>
            <Modal.Header>Cases</Modal.Header>
            <Modal.Content>
                {cases?.willCase && cases?.willCase !== 'n/a' && <>
                <Header>Will document classification:</Header>
                <Segment>
                    <Header>{cases.willCase}</Header>
                    <p>{cases?.willExplanation || ''}</p>
                </Segment>
                </>}

                {cases?.trustCase && cases?.trustCase !== 'n/a' && <>
                <Header>Revocable Trust document classification:</Header>
                <Segment>
                    <Header>{cases.trustCase}</Header>
                    <p>{cases?.trustExplanation || ''}</p>
                </Segment>
                </>}
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={closeBtn_Click}>Close</Button>
            </Modal.Actions>
        </Modal>
    )
}